// Vendors
import React from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

// Components
import { SalesCategoryFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageSalesCategoryShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { t } = useTranslation('salesCategory')
  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <LayoutLoggedPageList title={t(title)}>
      <SalesCategoryFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
